module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/badge-plan-b-4ba276dd84df4461165a692224efaf6e.svg";